"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
const propTypes = {
  errorMsg: _propTypes.default.node,
  onTryAgain: _propTypes.default.func,
  tryAgainBtnText: _propTypes.default.node,
  hasMoreRetries: _propTypes.default.bool,
  noMoreRetriesMsg: _propTypes.default.node
};
function ErrorAvailabilityTiles(_ref) {
  let {
    errorMsg,
    onTryAgain,
    tryAgainBtnText,
    hasMoreRetries,
    noMoreRetriesMsg
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ErrorContainer, {
    "data-testid": "AvailabilityTiles__Error"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, null, hasMoreRetries ? errorMsg : noMoreRetriesMsg), hasMoreRetries && /*#__PURE__*/_react.default.createElement(_styles.TryAgainButton, {
    mode: "flat",
    onClick: onTryAgain,
    "data-testid": "AvailabilityTiles__TryAgain"
  }, tryAgainBtnText)));
}
ErrorAvailabilityTiles.propTypes = propTypes;
var _default = exports.default = ErrorAvailabilityTiles;
ErrorAvailabilityTiles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorAvailabilityTiles",
  "props": {
    "errorMsg": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onTryAgain": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "tryAgainBtnText": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "hasMoreRetries": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "noMoreRetriesMsg": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};